import { apiConstructor as api } from '@/api/apiConstructor';
import { Redirect } from '@/types/redirects';
import { AxiosResponse } from 'axios';

export async function getRedirects(): Promise<Redirect[]> {
  const response: AxiosResponse = await api.get('redirects');
  return response.data;
}

export async function removeRedirect(id: string) {
  await api.delete(`redirects/${id}`);
}

export async function saveRedirect(redirect: Redirect): Promise<Redirect> {
  const url: string =
    redirect.id === undefined || '' ? 'redirects' : `redirects/${redirect.id}`;
  const response: AxiosResponse =
    redirect.id === undefined
      ? await api.post(url, redirect)
      : await api.put(url, redirect);

  return response.data;
}
